module.exports = __webpack_public_path__ + "static/media/Sept17-F18.c9f1b271.png";